// icon:toggle-switch | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from 'react'

function IconToggleSwitch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M17 7H7a5 5 0 00-5 5 5 5 0 005 5h10a5 5 0 005-5 5 5 0 00-5-5m0 8a3 3 0 01-3-3 3 3 0 013-3 3 3 0 013 3 3 3 0 01-3 3z" />
    </svg>
  )
}

export default IconToggleSwitch
